(function () {
  var ALLOWED_TAGS = { P: true, A: true, BR: true, B: true, STRONG: true, I: true, EM: true, SPAN: true, DIV: true };
  var BLOCK_TAGS = { P: true, DIV: true };
  var OMIT_TAGS = { SCRIPT: true, STYLE: true, IFRAME: true, OBJECT: true, SVG: true, MATH: true, TEMPLATE: true };

  function storefrontRoot(node) {
    var root = node.dataset.storefrontRoot || window.location.origin;
    var localeRoot = window.Shopify?.routes?.root || '/';
    return root.replace(/\/$/, '') + localeRoot.replace(/\/$/, '');
  }

  function localizedHref(href, node) {
    if (!href || /[\u0000-\u0020\u007f\\]/.test(href) || href.indexOf('//') === 0) return null;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (_) {
      return null;
    }
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null;
    if (url.origin !== 'https://www.fbrq.com') return href;

    var root = storefrontRoot(node);
    var rootUrl = new URL(root, window.location.origin);
    var prefix = rootUrl.pathname.replace(/\/$/, '');
    var pathname = url.pathname.replace(/^\/(?:en-ca|en-gb|en-eu|de-eu|es-eu|fr-eu|it-eu|nl-eu|en-hk|zh-hk|en-tw|zh-tw|en-au|en-sea|en-th)(?=\/|$)/, '') || '/';
    url.hostname = rootUrl.hostname;
    url.pathname = (prefix || '') + (pathname.charAt(0) === '/' ? pathname : '/' + pathname);
    return url.href;
  }

  function appendRichText(parent, source, points, node, insideLink) {
    if (source.nodeType === Node.TEXT_NODE) {
      var parts = source.nodeValue.split('{point}');
      parts.forEach(function (part, index) {
        if (part) parent.appendChild(document.createTextNode(part));
        if (index < parts.length - 1) {
          var value = document.createElement('span');
          value.className = 'designer-week-points__value';
          value.textContent = String(points);
          parent.appendChild(value);
        }
      });
      return;
    }
    if (source.nodeType !== Node.ELEMENT_NODE || OMIT_TAGS[source.tagName]) return;
    var tag = source.tagName.toLowerCase();
    if (!ALLOWED_TAGS[source.tagName]) {
      Array.prototype.forEach.call(source.childNodes, function (child) {
        appendRichText(parent, child, points, node, insideLink);
      });
      return;
    }
    if (BLOCK_TAGS[source.tagName] && parent.childNodes.length) parent.appendChild(document.createElement('br'));
    var destinationTag = source.tagName === 'DIV' ? 'span' : tag;
    var destination = document.createElement(destinationTag);
    if (source.tagName === 'SPAN' && /^#[\da-f]{3}(?:[\da-f]{3})?$/i.test(source.style.color)) {
      destination.style.color = source.style.color;
    }
    if (source.tagName === 'A') {
      var href = localizedHref(source.getAttribute('href') || '', node);
      if (href && !insideLink) {
        destination.setAttribute('href', href);
        destination.setAttribute('target', '_blank');
        destination.setAttribute('rel', 'noopener noreferrer');
      } else {
        destination = document.createElement('span');
      }
    }
    parent.appendChild(destination);
    Array.prototype.forEach.call(source.childNodes, function (child) {
      appendRichText(destination, child, points, node, insideLink || source.tagName === 'A');
    });
  }

  function renderContent(node, points) {
    if (node.dataset.contentRendered === 'true') {
      node.querySelectorAll('.designer-week-points__value').forEach(function (value) {
        if (value.textContent !== String(points)) value.textContent = String(points);
      });
      return;
    }
    var template = document.createElement('template');
    template.innerHTML = node.dataset.content || '';
    var fragment = document.createDocumentFragment();
    Array.prototype.forEach.call(template.content.childNodes, function (child) {
      appendRichText(fragment, child, points, node, false);
    });
    node.replaceChildren(fragment);
    node.dataset.contentRendered = 'true';
  }

  function refresh(root) {
    (root || document).querySelectorAll('[data-designer-week-points]').forEach(function (node) {
      if (node.dataset.context === 'product') {
        var productInfo = node.closest('.product__content');
        var price = productInfo?.querySelector('.product__price [data-price]');
        var displayedAmount = price?.getAttribute('data-price');
        if (displayedAmount != null && displayedAmount.trim() !== '' && Number.isFinite(Number(displayedAmount)) && Number(displayedAmount) >= 0) {
          node.dataset.amountMinor = displayedAmount;
        }
      }
      var amount = Number(node.dataset.amountMinor);
      var rate = Number(node.dataset.exchangeRate);
      var multiplier = Number(node.dataset.multiplier);
      if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(rate) || rate <= 0) return;
      var country = (node.dataset.countryCode || 'US').toUpperCase();
      var points = Math.round((amount / 100) * multiplier / (country === 'US' ? 1 : rate));
      renderContent(node, points);
      node.dataset.points = String(points);
    });
  }

  function refreshCartPoints(totalElement) {
    var amount = Number(totalElement.dataset.cartTotalPrice);
    if (!Number.isFinite(amount) || amount < 0) return;

    var drawer = totalElement.closest('cart-drawer');
    var summaryColumn = totalElement.closest('.cart__summary-column');
    var scope = drawer || summaryColumn || document;
    var pointsNodes = scope.querySelectorAll(
      '[data-designer-week-points][data-context="cart"]'
    );

    pointsNodes.forEach(function (node) {
      node.dataset.amountMinor = String(amount);
    });
    refresh(scope);
  }

  function observeCartTotal() {
    if (!('MutationObserver' in window)) return;

    var refreshFrame;
    function scheduleCartPointsRefresh() {
      window.cancelAnimationFrame(refreshFrame);
      refreshFrame = window.requestAnimationFrame(function () {
        document.querySelectorAll('[data-cart-total-price]').forEach(
          refreshCartPoints
        );
      });
    }

    var observer = new MutationObserver(function (mutations) {
      var cartChanged = mutations.some(function (mutation) {
        return (
          (mutation.type === 'attributes' &&
            mutation.attributeName === 'data-cart-total-price') ||
          (mutation.type === 'childList' &&
            mutation.target.closest?.('cart-drawer, .cart__summary-column'))
        );
      });

      if (cartChanged) scheduleCartPointsRefresh();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-cart-total-price'],
      childList: true,
      subtree: true,
    });
  }

  window.DesignerWeekPoints = { refresh: refresh };

  function refreshProductPoints(data, target) {
    var variant = data?.variant;
    if (!variant || variant.price == null) return;
    var productInfo;
    if (data.sectionId) {
      productInfo = document.getElementById('ProductInfo-' + data.sectionId);
      if (!productInfo) return;
    } else {
      productInfo = target?.closest?.('.product__content, product-info');
      if (!productInfo) return;
    }
    productInfo.querySelectorAll('[data-designer-week-points][data-context="product"]').forEach(function (node) {
      node.dataset.amountMinor = String(variant.price);
    });
    refresh(productInfo);
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    document.querySelectorAll('[data-cart-total-price]').forEach(refreshCartPoints);
    observeCartTotal();
  });
  document.addEventListener('variant-change', function (event) {
    refreshProductPoints(event.detail?.data || event.detail, event.target);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      refreshProductPoints(event?.data);
    });
  }
})();
